import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowLeftRight } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

export function PhotoCompare({ a, b, onClose }) {
  const [pos, setPos] = useState(50);
  if (!a || !b) return null;
  const [before, after] = new Date(a.created_at) <= new Date(b.created_at) ? [a, b] : [b, a];
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="photo-compare" className="max-w-4xl">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><ArrowLeftRight className="h-5 w-5 text-[#D97706]" /> Season compare</DialogTitle>
          <DialogDescription>Drag the slider to see how this spot changed between the two dates.</DialogDescription>
        </DialogHeader>
        <div className="relative w-full aspect-[4/3] max-h-[70vh] rounded-xl overflow-hidden bg-black select-none">
          <img src={after.thumb_data_url} alt="after" className="absolute inset-0 w-full h-full object-contain" draggable={false} />
          <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
            <img src={before.thumb_data_url} alt="before" className="absolute inset-0 h-full object-contain" style={{ width: `${10000 / pos}%`, maxWidth: "none" }} draggable={false} />
          </div>
          <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
            <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-10 w-10 rounded-full bg-white text-[#143D29] flex items-center justify-center shadow-lg"><ArrowLeftRight className="h-5 w-5" /></div>
          </div>
          <span className="absolute top-3 left-3 text-xs font-bold uppercase tracking-wider bg-black/60 text-white px-2 py-1 rounded">Before · {fmt(before.created_at)}{before.score != null ? ` · ${Math.round(before.score)}` : ""}</span>
          <span className="absolute top-3 right-3 text-xs font-bold uppercase tracking-wider bg-[#2D6A4F]/90 text-white px-2 py-1 rounded">After · {fmt(after.created_at)}{after.score != null ? ` · ${Math.round(after.score)}` : ""}</span>
          <input data-testid="compare-slider" type="range" min="2" max="98" value={pos} onChange={(e) => setPos(Number(e.target.value))}
            className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" aria-label="Compare slider" />
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm text-stone-600">
          <div><b className="text-emerald-950">Before:</b> {before.caption || before.kind}</div>
          <div className="text-right"><b className="text-emerald-950">After:</b> {after.caption || after.kind}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
